
import { User } from './user.model';
import { OnboardingStatus } from '../Interfaces/enums';

export interface OnboarderData {
  user_id: number;
  first_name: string | null;
  last_name: string | null;
  email: string;
  phone: string | null;
}

export interface CompanyData {
  domain: string;
  name: string;
  avyna_nickname: string;
}

export interface PlanData {
  plan_id: string;
  plan_code: string;
  offer_type: string;
  market_id: string;
  currency: string;
  agent_price_id: string | null;
  seat_price_id: string;
  user_licences: number;
  device_licences: number;
}

export interface StripeData {
  stripe_customer_id: string | null;
  checkout_session_id: string | null;
  payment_method_id: string | null;
}

export class Onboarding {
  id!: string;
  user_id!: number | null;
  tenant_id!: string;
  status!: OnboardingStatus;
  onboarder_data!: OnboarderData | null;
  company_data!: CompanyData | null;
  plan_data!: PlanData | null;
  stripe_data!: StripeData | null;
  admin_consent_granted_at!: string | null;
  created_at!: string;
  updated_at!: string;
  deleted_at!: string | null;
  user?: User;

  constructor(data: Partial<Onboarding>) {
    Object.assign(this, data);

    if (data.user) {
      this.user = new User(data.user);
    }
  }


  hasAdminConsent(): boolean {
    return !!this.admin_consent_granted_at;
  }

  get isPaymentVerified(): boolean {
    return !!this.stripe_data?.payment_method_id;
  }

}

